import { createAction, props } from '@ngrx/store';
import { Product } from '../models/manage-offerings.model';
import { IProductSolutions } from '../models/product-solutions.model';

export const loadManageOfferings = createAction('[ManageOfferings] Load ManageOfferingss', props<{ request: string }>());

export const loadManageOfferingsSuccess = createAction('[ManageOfferings] Load ManageOfferingss Success', props<{ response: Product[] }>());

export const loadManageOfferingsFailure = createAction('[ManageOfferings] Load ManageOfferingss Failure', props<{ error: Error | any }>());

export const loadClearManageOfferings = createAction('[ManageOfferings] Clear ManageOfferingss Failure');

//saveAllProductSolutions
export const saveAllProductSolutions = createAction(
  '[ManageOfferings] Save ManageOfferings',
  props<{ businessId: string; request: IProductSolutions }>()
);

export const saveAllProductSolutionsSuccess = createAction('[ManageOfferings] Save ManageOfferings Success', props<{ response: string }>());

export const saveAllProductSolutionsFailure = createAction(
  '[ManageOfferings] Save ManageOfferings Failure',
  props<{ error: Error | any }>()
);
